module.exports = __webpack_public_path__ + "static/media/Add Mail.12e25a70.svg";